import AspectRatioBox, { type AspectRatioBoxRatio } from '@ingka/aspect-ratio-box'
import Image, { type ImageAttributes, type ImageProps } from '@ingka/image'

import { aspectRatioBox } from './image-with-aspect-ratio.module.css'

type ImageWithAspectRatioProps = {
  aspectRatio?: AspectRatioBoxRatio
} & ImageAttributes &
  ImageProps

export function ImageWithAspectRatio({ aspectRatio, ...rest }: ImageWithAspectRatioProps) {
  return (
    <AspectRatioBox className={aspectRatioBox} ratio={aspectRatio}>
      <Image {...rest} />
    </AspectRatioBox>
  )
}
